<div class="app-phone-wrapper" [ngClass]="customClass">
  <!-- Header Label -->
  <app-label
    *ngIf="resolvedLabel"
    [text]="resolvedLabel"
    [mandatory]="isRequired"
    [optional]="optional"
    [tooltip]="tooltip"
    [icon]="labelIcon"
    [size]="labelSize"
  ></app-label>

  <!-- Combined Input Container -->
  <div
    class="app-phone-container"
    [ngClass]="[
      'app-phone-container--' + (size || 'md'),
      isFocused ? 'app-phone-container--focused' : '',
      hasError ? 'app-phone-container--error' : '',
      disabled ? 'app-phone-container--disabled' : '',
      readonly ? 'app-phone-container--readonly' : ''
    ]"
    [style.height]="resolvedHeight ? resolvedHeight : null"
    [style.minHeight]="resolvedHeight ? resolvedHeight : null"
  >
    <!-- Country Code Picker Trigger -->
    <button type="button" class="app-phone__country-picker" (click)="toggleDropdown($event)" [disabled]="disabled">
      <span class="app-phone__flag">
        <img
          *ngIf="selectedCountry?.flagUrl"
          [src]="selectedCountry?.flagUrl"
          alt=""
        />
      </span>
      <span class="app-phone__dial-code">+{{ selectedCountry?.code || '91' }}</span>
      <span class="app-phone__chevron" [ngClass]="{ 'app-phone__chevron--open': isDropdownOpen }">
        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1 1L5 5L9 1"
            stroke="#7C8896"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </button>

    <!-- Phone Number Input Field -->
    <input
      type="tel"
      class="app-phone__input"
      [value]="value"
      (input)="onPhoneInput($event)"
      (keydown)="onKeyDown($event)"
      (blur)="onBlur($event)"
      (focus)="onFocus($event)"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [readonly]="readonly"
      [attr.maxlength]="effectiveMaxLength"
      autocomplete="tel"
    />

    <!-- Country Dropdown Overlay -->
    <div *ngIf="isDropdownOpen" class="app-phone__dropdown" (click)="$event.stopPropagation()">
      <!-- Search Input -->
      <div class="app-phone__search-box">
        <svg width="14" height="14" viewBox="0 0 16 16" fill="#94a3b8" class="app-phone__search-icon">
          <path
            d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
          />
        </svg>
        <input
          type="text"
          class="app-phone__search-input"
          placeholder="Search country or code..."
          [value]="searchTerm"
          (input)="onSearch($event)"
          autofocus
        />
      </div>

      <!-- Countries List -->
      <div class="app-phone__countries-list">
        <div
          *ngFor="let c of filteredCountries; trackBy: trackByCountry"
          class="app-phone__country-item"
          [ngClass]="{ 'app-phone__country-item--selected': c.code === selectedCountry?.code && c.iso === selectedCountry?.iso }"
          (click)="selectCountry(c, true)"
        >
          <span class="app-phone__country-flag">
            <img [src]="c.flagUrl" alt="" />
          </span>
          <span class="app-phone__country-name">{{ c.country }}</span>
          <span class="app-phone__country-code">+{{ c.code }}</span>
        </div>

        <div *ngIf="filteredCountries.length === 0" class="app-phone__no-results">
          No countries found
        </div>
      </div>
    </div>
  </div>

  <!-- Error Message -->
  <div *ngIf="hasError" class="app-phone__error">
    {{ errorMsg }}
  </div>

  <!-- Helper Text -->
  <div *ngIf="helperText && !hasError" class="app-phone__helper">
    {{ helperText }}
  </div>
</div>
